import general from './general'
import jira from './jira'
import rules from './rules'
import questions from './questions'
import exampleMap from './exampleMap'
import notes from './notes'

import { combineReducers } from 'redux'

const RootReducer = combineReducers({
  general,
  jira,
  exampleMap,
  rules,
  questions,
  notes
})

export default RootReducer
